<template>
  <div>
    <DefaultCard class="z-20 select-none">
      <Heading class="mb-16" center>Invoices</Heading>

      <Spinner v-if="loading" class="mx-auto mt-4" />

      <TableComponent v-if="invoices && invoices.length > 0" :headers="['ID', 'TYPE', 'AMOUNT', 'STATUS', 'DATE']" :data="invoices" />
      <div v-else>No invoices available</div>

    </DefaultCard>
  </div>
</template>

<script>
import DefaultCard from "../layout/DefaultCard";
import Heading from "../Heading";
import StyledButton from "@/components/common/controls/StyledButton";
import TableComponent from "@/components/common/TableComponent";
import Spinner from "@/components/common/Spinner";
import ApiV1 from "@/api/api_v1.0";



export default {
  name: "AccountInvoices",
  components: {
    Heading,
    DefaultCard,
    TableComponent,
    StyledButton,
    Spinner
  },
  data() {
    return {
      invoices: null,
      loading: false
    };
  },

  async created() {
    const response = await ApiV1.getUserInvoices();
    this.invoices = response.data.map( item => {
      return  {
        id: item.transaction_id,
        type: item.source_type,
        amount: item.price,
        status: item.status,
        date: item.human_date
      }
    });
  },

  methods: {}
};
</script>
